module.exports = __webpack_public_path__ + "images/CEBSB_goodnews_bg_up_2025_2026_en.1788405320306.png";